import { registerPlugin } from '@capacitor/core';
const Sahha = registerPlugin('Sahha', {
    web: () => import('./web').then((m) => new m.SahhaWeb()),
});
export * from './definitions';
export { Sahha };
//# sourceMappingURL=index.js.map